import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { RoomConfigurationActionTypes, RoomConfigurationActionsUnion } from './room-configuration.actions';

export const inroomRoomConfigurationsKey = 'inroom-room-configurations';

export class RoomConfiguration {
  hotelCode: string;
  unitCode: string;
  token: string;
}

export type RoomConfigurationsState = EntityState<RoomConfiguration>;

export function selectRoomConfigurationId(roomConfiguration: RoomConfiguration): string {
  return `${roomConfiguration.hotelCode}-${roomConfiguration.unitCode}`;
}

export const adapter: EntityAdapter<RoomConfiguration> = createEntityAdapter<RoomConfiguration>({
  selectId: selectRoomConfigurationId,
});

export const initialState: RoomConfigurationsState = adapter.getInitialState({});

export function roomConfigurationsReducer(
  state: RoomConfigurationsState = initialState,
  action: RoomConfigurationActionsUnion
): RoomConfigurationsState {
  switch (action.type) {
    case RoomConfigurationActionTypes.ROOM_CONFIGURATION_LOADED:
      return adapter.upsertOne(action.payload, state);
    default:
      return state;
  }
}

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectRoomConfigurationIds = selectIds;

export const selectRoomConfigurationEntities = selectEntities;

export const selectAllRoomConfigurations = selectAll;

export const selectRoomConfigurationsTotal = selectTotal;
